import { render, staticRenderFns } from "./purchase_orders.vue?vue&type=template&id=6e44fc64&scoped=true&"
import script from "./purchase_orders.vue?vue&type=script&lang=js&"
export * from "./purchase_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e44fc64",
  null
  
)

export default component.exports